import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../../services/Toast.service";
import {StateService} from "../../../services/StateService";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {ActivatedRoute, Router} from "@angular/router";
import {TemplatesService} from "../../../tpiq-services/templates.service";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {TaxPlanningService} from "../../../tpiq-services/tax-planning.service";
import {Session} from "../../../services/Session";
import {PageTitleService} from "../../../services/PageTitle";
import {TpiqSelectDropdownComponent} from "../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {FormatAmountPipe} from "../../../pipes/format-amount.pipe";
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {MatExpansionModule} from "@angular/material/expansion";
import {ModelBasedNumeral} from "../../../directives/model-numeral";
import { environment } from '../../../../environments/environment';

declare const _: any;

@Component({
  selector: 'app-create-or-update-template',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, TpiqSelectDropdownComponent, FormatAmountPipe, FroalaEditorModule, MatExpansionModule],
  templateUrl: './create-or-update-template.component.html',
  styleUrl: './create-or-update-template.component.scss'
})
export class CreateOrUpdateTemplateComponent implements OnInit, OnDestroy {
  @Input() editMode: any;
  @Input() templateId: string;
  @Input() isFromPlan: any;
  @Input() selectedStrategiesFromPlan: any;
  @Output() onCancelCreateOrUpdateOfTemplate: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreationOrUpdateOfTemplate: EventEmitter<any> = new EventEmitter<any>();
  org: string = Session.getOrg();
  user: any = {};
  template: any = {
    id: '',
    rates: [],
    fees: [],
    strategies: []
  };
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  currentSection = 'info';
  editorOptions = {
    heightMin: 100,
    heightMax: 100,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Template notes',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  associatedWithData: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: 'b870c7b6-802f-11eb-8aa0-1282986503dc', name: 'Non-deductible'},
    {id: '393a6f91-8222-11ef-bd9d-12ff30f54e53', name: 'Full Credit'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate'},
    {id: 'ce08f4de-b7f2-449c-9bf8-9674fbf6d0d5', name: 'Qualified Dividends'},
    {id: 'fba5d8f4-c3f3-46db-aaf4-df85b1945ad3', name: 'State Individual Rate'}];
  strategiesList: Array<any> = [];
  allAssociatedData: any = {};
  rateColumns: Array<any> = [
    {name: 'name', title: 'Rate Name', type: 'normal', classes: 'pointer zero-overflow', sortable: true},
    {name: 'rate', title: 'Rate', type: 'normal', classes: 'pointer zero-overflow tracker-desc', sortable: true}
  ];
  feesColumns: Array<any> = [
    {name: 'description', title: 'Fees Description', type: 'normal', classes: 'pointer zero-overflow', sortable: true},
    {name: 'amount', title: 'Amount', type: 'normal', classes: 'pointer zero-overflow tracker-desc', sortable: true},
    {name: 'associatedWithName', title: 'Associated With', type: 'normal', classes: 'pointer zero-overflow tracker-desc', sortable: true}
  ];
  strategiesColumns: Array<any> = [
    {name: 'strategyName', title: 'Strategy', type: 'normal', classes: 'pointer zero-overflow', sortable: true},
    {name: 'amount', title: 'Amount', type: 'normal', classes: 'pointer zero-overflow tracker-desc', sortable: true},
    {name: 'associatedWithName', title: 'Applicable To', type: 'normal', classes: 'pointer zero-overflow tracker-desc', sortable: true},
    {name: 'recurring', title: 'Recurring', type: 'normal', classes: 'pointer zero-overflow tracker-desc', sortable: true}
  ];
  tempTemplate: any = {
    id: '',
    rates: [],
    fees: [],
    strategies: []
  };
  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private titleService: PageTitleService,
    private loadingService: LoadingService,
    private stateService: StateService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private taxPlanningService: TaxPlanningService,
    private taxStrategyServices: ManageTaxStrategiesServices,
    private templatesService: TemplatesService
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.getStrategiesList();

    if (this.editMode) {
      this.getTemplate();
    } else {
      this.template = {
        id: '',
        rates: [],
        fees: [],
        strategies: (this.isFromPlan) ? this.selectedStrategiesFromPlan : []
      };

    }
  }

  getTemplate(){
    this.loadingService.triggerLoadingEvent(true);
    this.templatesService.getTemplate(this.org, this.user.id, this.templateId).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.template = response;
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, 'Failed to get template info');
    });
  }

  getStrategiesList() {
    let obj: any = {
      fromIndex: -1
    }
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.getPaginatedTaxStrategies(this.org, this.user.id, obj, true)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.strategiesList = response.strategies;
        this.buildAssociatedObject();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To get strategies data');
      });
  }

  buildAssociatedObject(){
    const base = this;
    this.associatedWithData = [...this.associatedWithData];
    _.each(this.strategiesList, (obj) => {
      let strategyRates = [...base.associatedWithData];
      if (obj.customTaxRates){
        strategyRates = strategyRates.concat(obj.customTaxRates);
      }
      base.allAssociatedData[obj.id] = strategyRates;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  goToPreviousSection() {
    this.currentSection = this.getSectionName('previous');
  }

  goToNextSection() {
    if (this.getSectionName('next') == 'review') {
      this.tempTemplate = _.cloneDeep(this.template);
      this.formatFeeLinesData();
      this.formatStrategiesData();
    }
    this.currentSection = this.getSectionName('next');
  }

  formatFeeLinesData() {
    const base = this;
    this.tempTemplate.fees = this.tempTemplate.fees || [];
    _.each(this.tempTemplate.fees, (fee) => {
      const obj = _.find(base.associatedWithData, {id: fee.associatedWith});
      if (obj) {
        fee.associatedWithName = obj.name;
      }
    });
  }

  formatStrategiesData() {
    const base = this;
    this.tempTemplate.strategies = this.tempTemplate.strategies || [];
    _.each(this.tempTemplate.strategies, (strategy) => {
      const rates = this.allAssociatedData[strategy.strategyId] || [];
      const obj = _.find(rates, {id: strategy.associatedWith});
      if (obj) {
        strategy.associatedWithName = obj.name;
      }
      const strObj = _.find(base.strategiesList, {id: strategy.strategyId});
      if (strObj) {
        strategy.strategyName = strObj.name;
        strategy.strategyType = strObj.type;
        strategy.locked = strObj.locked;
      }
    });
  }

  getSectionName(type) {
    let nextSecName = '';
    let previousSecName = '';
    if (this.currentSection == 'info') {
      nextSecName = 'structure';
    } else if (this.currentSection == 'structure') {
      nextSecName = 'review';
      previousSecName = 'info';
    } else if (this.currentSection == 'review') {
      previousSecName = 'structure';
    }
    return (type == 'previous') ? previousSecName : nextSecName;
  }

  closeCreateOrUpdatePopup() {
    this.onCancelCreateOrUpdateOfTemplate.emit();
  }

  appendRate() {
    this.template.rates.push({
      name: '',
      rate: 0,
      formula: {
        actualValue: '',
        displayValue: '',
        displayValuesArray: [],
        actualValuesArray: []
      }
    });
  }

  appendFees() {
    this.template.fees.push({description: '', amount: 0});
  }

  appendStrategy() {
    this.template.strategies.push({strategyId: '', amount: 0, associatedWith: '', recurring: false});
  }

  deleteRate(index) {
    this.template.rates.splice(index, 1);
  }

  deleteFees(index) {
    this.template.fees.splice(index, 1);
  }

  deleteStrategy(index) {
    this.template.strategies.splice(index, 1);
  }

  setAssociatedWith($event, line){
    line['associatedWith'] = $event.id;
  }

  setStrategy($event, strategy){
    strategy['strategyId'] = $event.id;
    if ($event.associatedWith){
      strategy['associatedWith'] = $event.id;
    }
  }

  saveTemplate() {
    if (!this.validateData()){
      return;
    }
    if (this.editMode){
      this.loadingService.triggerLoadingEvent(true);
      this.templatesService.updateTemplate(this.org, this.user.id, this.template).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Template updated successfully');
        this.onCreationOrUpdateOfTemplate.emit();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to update template');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update template');
        }
      });
    } else {
      _.each(this.template.fees, (fee) => {
        fee.frequency = 'Yearly';
        fee.type = 'Third Party';
      });
      _.each(this.template.rates, (rate) => {
        rate.formula = JSON.stringify(rate.formula);
      });
      this.loadingService.triggerLoadingEvent(true);
      this.templatesService.createTemplate(this.org, this.user.id, this.template).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Template created successfully');
        this.onCreationOrUpdateOfTemplate.emit();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          const message = error.message ? error.message : 'Failed to create template';
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to create template');
        }
      });
    }
  }

  validateData(){
    const base = this;
    let result = true;
    if (!this.template.name){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Template Name');
      return false;
    }
    if (this.template.strategies && this.template.strategies.length > 0) {
      _.each(this.template.strategies, (strategy) => {
        if (!strategy.strategyId){
          result = false;
        }
      });
      if (!result) {
        base.toastService.pop(TOAST_TYPE.error, `Strategy is mandatory for strategy line item.`);
        return false;
      }
    }
    if (this.template.fees && this.template.fees.length > 0) {
      result = true
      _.each(this.template.fees, (fee) => {
        if (!fee.description){
          result = false;
        }
      });
      if (!result) {
        base.toastService.pop(TOAST_TYPE.error, `Description is mandatory for fee line item.`);
        return false;
      }
    }
    if (this.template.rates && this.template.rates.length > 0) {
      result = true
      _.each(this.template.rates, (rate) => {
        if (!rate.name){
          result = false;
        }
      });
      if (!result) {
        base.toastService.pop(TOAST_TYPE.error, `Name is mandatory for rate line item.`);
        return false;
      }
    }
    return true;
  }

  goToReviewSection() {
    this.currentSection = 'review';
    this.tempTemplate = _.cloneDeep(this.template);
    this.formatFeeLinesData();
    this.formatStrategiesData();
  }

}
